export const bottomInfoMessages = [
  '• 불량조회 화면에서는 생산과정에서 발생한 불량 정보를 조회할 수 있습니다.',
  '• 불량 유형, 원인, 수량 등의 정보를 확인하여 품질 관리에 활용할 수 있습니다.',
  '• 출력 및 엑셀 내보내기 기능을 통해 불량 데이터를 활용할 수 있습니다.',
];

export const helpModalMessages = {
  title: '불량조회 도움말',
  paragraphs: [
    '• 불량조회에서는 생산 과정에서 발생한 불량 정보를 조회할 수 있습니다.',
    '• 상단의 검색조건을 사용하여 특정 기간, 제품, 작업지시 등의 불량 정보를 조회할 수 있습니다.',
    '• 그리드의 컬럼을 클릭하여 정렬하거나, 필터 기능을 사용하여 데이터를 필터링할 수 있습니다.',
    '• 출력 및 엑셀 내보내기 기능을 통해 불량 데이터를 활용할 수 있습니다.',
  ],
}; 